import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { giftArt } from "@/lib/api";
import { cad } from "@/lib/site";

export const BundleTile = ({ b }) => (
  <Link to={`/bundles/${b.slug}`} className="group block" data-testid={`bundle-card-${b.slug}`}>
    <div className="tile relative aspect-[4/5]"><img src={b.image} alt={b.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" loading="lazy" />
      {b.save > 0 && <span className="label absolute left-3 top-3 rounded-full bg-pink px-3 py-1 font-bold">Save {cad(b.save)}</span>}</div>
    <h3 className="font-a mt-4 text-[17px]">{b.name}</h3>
    <p className="mt-1 text-sm">{cad(b.price)} <span className="text-ink/45 line-through">{cad(b.value)} value</span></p>
  </Link>
);

export const GiftTile = () => (
  <Link to="/gift-cards" className="group block" data-testid="gift-card-tile">
    <div className="tile flex aspect-[4/5] items-center bg-pink p-4"><img src={giftArt("lime", 50)} alt="SUS GIFT card" className="w-full -rotate-3 rounded-[12px] transition-transform duration-500 group-hover:rotate-0" loading="lazy" /></div>
    <h3 className="font-a mt-4 text-[17px]">Sus Gift Card</h3>
    <p className="mt-1 text-sm">C$25 · C$50 · C$100</p>
  </Link>
);

export const HomeBundle = ({ b }) => b ? (
  <section className="mx-auto max-w-[1440px] px-5 pb-8 sm:px-10" aria-labelledby="bundle-title" data-testid="home-bundle">
    <Link to={`/bundles/${b.slug}`} className="group grid items-center gap-6 overflow-hidden rounded-[24px] border-[1.5px] border-ink bg-sky sm:grid-cols-[220px_1fr_auto]">
      <img src={b.image} alt={b.name} className="aspect-square h-full w-full object-cover" loading="lazy" />
      <div className="px-6 sm:px-0"><p className="label font-bold">Bundle deal · you save {cad(b.save)}</p><h2 id="bundle-title" className="display mt-2 text-5xl">{b.name}</h2><p className="font-a mt-2 text-[15px]">Any tee + Certified Sus Cap + Sus Sticker Sheet. {cad(b.price)} instead of {cad(b.value)}.</p></div>
      <span className="btn btn-ink mx-6 mb-6 sm:mb-0" data-testid="home-bundle-cta">Build yours <ArrowRight size={16} /></span>
    </Link>
  </section>
) : null;
